import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, FeatureGuard } from 'src/app/guards';
import { CorporateEntitySearchComponent } from './components/corporate-entity-search/corporate-entity-search.component';
import { NoAccessComponent } from 'src/app/components/no-access/no-access.component';
const routes: Routes = [
  {
    path: 'corporateentities',
    component: CorporateEntitySearchComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: {feature: 'UI::CorporateEntityList'}
  },
  {
    path: 'no-access',
    component: NoAccessComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorporateEntityRoutingModule { }
